
import { PageHeaderResponseJSON } from "./../surveyHeader/Page-Header-Response-JSON";
import { PageFooterResponseJSON } from "./../surveyFooter/Page-Footer-Response-JSON";
import { QuestionDetailsHeaderRequestJSON } from "./Question-Details-Header-Request.JSON";

export class SurveyDeployerQuestionPageRequestJSON {
    surveyID: Number;
    surveyUserID: Number;
    questionPageHeaderResponseJSON: PageHeaderResponseJSON;
    questionPageFooterResponseJSON: PageFooterResponseJSON;
    questionDetailsHeaderRequestJSON: QuestionDetailsHeaderRequestJSON;
    userID: Number;
    tenantID: Number;
    contextEntityId: Number;
    contextInstanceId: Number;
    roleID: Number;
    sysSurveyRunID: Number;
    isHistorical: boolean;
}